export const has_at_least_one_element = function (stash, to_seek) {
  // Receive a string stash representing a list of comma separated elements
  // Use the to_seek array to return true or false:
  // if at least one of the elements in to_seek is present in stash, return true
  if (to_seek.length === 0) {
    return true;
  }
  const elements = stash;

  for (const key in elements) {
    if (elements.hasOwnProperty(key)) {
      const element = elements[key];
      if (to_seek.includes(element)) {
        return true;
      }
    }
  }
  return false;
};
